// src/Hooks/useResidentials.js

import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { utils } from "../Helpers/utils";
import { UsersServices } from "../Container/Users/User/users.service";
import { setResidentials } from "../Container/Invoice/reducer";

export const useResidentials = () => {
  const dispatch = useDispatch();
  const residentials = useSelector((state) => state.Invoice.residentials);
  const [loading, setLoading] = useState(false);

  const loadResidentials = useCallback(
    async (force = false) => {
      if (utils.evaluateArray(residentials) && !force) return;

      setLoading(true);
      try {
        const response = await UsersServices.getAllResidential();
        if (response?.success) {
          dispatch(setResidentials(response.residentials));
        }
      } catch (error) {
        console.error("Error al cargar las residenciales:", error);
      } finally {
        setLoading(false);
      }
    },
    [dispatch, residentials]
  );

  // Cargar automáticamente al inicializar
  useEffect(() => {
    loadResidentials();
  }, [loadResidentials]);

  return {
    residentials,
    loading,
    refetch: loadResidentials,
  };
};
